import { render, staticRenderFns } from "./ShelfByOrder.vue?vue&type=template&id=28967694"
import script from "./ShelfByOrder.vue?vue&type=script&lang=js"
export * from "./ShelfByOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports